import { useMainStore } from "@/stores/main";
import { RouteLocationRaw, useRouter } from "vue-router";
import { ROUTE_PATHS } from "./types";
import { useProposalStore } from "@/stores/risk/risk";

const useNavigationHelpers = () => {
    const router = useRouter();
    const proposalStore = useProposalStore();
    const mainStore = useMainStore();

    async function goToPreviouslyRecordedRoute() {
        const previousRoute = mainStore.previousRoute;
        if (previousRoute) {
            await router.push(previousRoute?.fullPath);
        } else {
            const homeRoute: RouteLocationRaw = {
                name: ROUTE_PATHS.AboutYou
            };
            if (proposalStore.proposal.uuid) {
                homeRoute.query = {
                    uuid: proposalStore.proposal.uuid
                };
            }
            await router.push({
                name: ROUTE_PATHS.AboutYou
            });
        }
    }
    return {
        goToPreviouslyRecordedRoute
    };
};

export default useNavigationHelpers;
